import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { ErrorBoundary } from "./components/ErrorBoundary.tsx";
import { ErrorFallback } from "./components/ErrorFallback.tsx";
import { initSentry, Sentry } from "./lib/sentry.ts";
import { captureAttribution } from "./lib/attribution.ts";
import "./index.css";

// Initialise Sentry as early as possible so errors thrown during render are captured.
initSentry();

// First-touch attribution: capturar UTM + referrer del landing antes del render.
captureAttribution();

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </Sentry.ErrorBoundary>,
);
